import { 
  DashboardOutlined,
  UserOutlined,
  ClockCircleOutlined,
  SnippetsOutlined,
  FileDoneOutlined,
  IdcardOutlined,
  QuestionCircleOutlined,
  CustomerServiceOutlined,
  ScheduleOutlined,
  ControlOutlined,
  UsergroupAddOutlined,
  AreaChartOutlined,
  SettingOutlined,
  ProjectOutlined
} from '@ant-design/icons';
import { faTicket } from '@fortawesome/free-solid-svg-icons'
import { APP_PREFIX_PATH/*, AUTH_PREFIX_PATH*/ } from 'configs/AppConfig'
import Utils from 'utils';

const dashBoardNavTree = [{
  key: 'dashboard',
  path: `${APP_PREFIX_PATH}/dashboard`,
  title: Utils.CurrentUserApplication() === "SAMAC" ? 'dashboard' : 'dashboard_levrangi',
  icon: DashboardOutlined,
  breadcrumb: true,
  submenu: []
},
{
  key: 'hours',
  path: `${APP_PREFIX_PATH}/hours`,
  title: 'hours',
  defaultOpen: true,
  icon: ClockCircleOutlined,
  isSeparator: true,
  breadcrumb: true,
  submenu: [
    {
      key: 'hours_list',
      path: `${APP_PREFIX_PATH}/hours_list`,
      title: 'hours_list',
      breadcrumb: false,
      submenu: []
    },
    {
    key: 'hours_endorsement',
    path: `${APP_PREFIX_PATH}/hours_endorsement`,
    title: 'hours_endorsement',
    breadcrumb: false,
    submenu: [],
    },
    {
      key: 'hours_analysis',
      path: `${APP_PREFIX_PATH}/hours_analysis`,
      title: 'hours_analysis',
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'hours_analysis_user',
      path: `${APP_PREFIX_PATH}/hours_analysis_user`,
      title: 'hours_analysis_user',
      breadcrumb: false,
      submenu: []
    }
  ]
},
{
    key: 'hours',
    path: `${APP_PREFIX_PATH}/hours_template`,
    title: 'hours_template',
    icon: ClockCircleOutlined,
    breadcrumb: true,
    hidden: true,
    submenu: []
}, 
{
  key: 'templates',
  path: `${APP_PREFIX_PATH}/templates/list`,
  title: 'templates',
  icon: SnippetsOutlined,
  breadcrumb: true,
  submenu: [{
    key: 'templates_edit',
    parentKey: 'templates',
    path: `${APP_PREFIX_PATH}/templates/edit/`,
    title: 'editTemplate',
    icon: UserOutlined,
    breadcrumb: true,
    hidden: true,
    submenu: []
  }]
},
{
  key: 'jobs',
  path: `${APP_PREFIX_PATH}/jobs`,
  title: 'jobs',
  icon: ProjectOutlined,
  isSeparator: true,
  defaultOpen: false,
  breadcrumb: true, 
  submenu: [
    {
      key: 'jobs_list',
      parentKey: 'jobs_list',
      path: `${APP_PREFIX_PATH}/jobs_list`,
      title: 'jobs_list',
      submenu: []
    },
    {
      key: 'jobs_tasks',
      parentKey: 'jobs',
      path: `${APP_PREFIX_PATH}/jobs_tasks`,
      title: 'jobs_tasks',
      submenu: []
    }]
},
{
  key: 'reports',
  path: `${APP_PREFIX_PATH}/reports_list`,
  title: 'reports',
  icon: FileDoneOutlined,
  isSeparator: true,
  defaultOpen: false,
  breadcrumb: true,
  submenu: [
    {
      key: 'reports_list',
      parentKey: 'reports_list',
      path: `${APP_PREFIX_PATH}/reports_list`,
      title: 'reports_list',
      submenu: []
    },
    {
      key: 'reports_analysis',
      parentKey: 'reports_analysis',
      path: `${APP_PREFIX_PATH}/reports_analysis`,
      title: 'reports_analysis',
      submenu: []
    },
    {
      key: 'reports_edit',
      parentKey: 'reports_list',
      path: `${APP_PREFIX_PATH}/reports/edit/`,
      title: 'editReport',
      icon: FileDoneOutlined,
      breadcrumb: true,
      hidden: true,
      submenu: []
    }]
},
{
  key: 'tickets',
  title: 'tickets',
  iconFA: faTicket,
  isSeparator: true,
  defaultOpen: false,
  breadcrumb: true,
  submenu: [
    {
      key: 'tickets_new',
      parentKey: 'tickets_new',
      path: `${APP_PREFIX_PATH}/tickets_new`,
      title: 'tickets_new',
      submenu: []
    },
    {
      key: 'tickets_edit',
      parentKey: 'tickets_list',
      path: `${APP_PREFIX_PATH}/tickets/edit/`,
      title: 'editTicket',
      icon: FileDoneOutlined,
      breadcrumb: true,
      hidden: true,
      submenu: []
    },
    {
      key: 'tickets_list',
      parentKey: 'tickets_list',
      path: `${APP_PREFIX_PATH}/tickets_list`,
      title: 'tickets_list',
      submenu: []
    }]
},
{
  key: 'users',
  path: `${APP_PREFIX_PATH}/users`,
  title: 'users',
  icon: UserOutlined,
  isSeparator: true,
  defaultOpen: false,
  breadcrumb: true,
  submenu: [
    {
      key: 'users_management',
      path: `${APP_PREFIX_PATH}/users_management`,
      title: 'users_management',
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'users_presence_list',
      path: `${APP_PREFIX_PATH}/users_presence_list`,
      title: 'users_presence_list',
      isSeparator: true,
      defaultOpen: true,
      breadcrumb: true,
    },
    {
      key: 'users_discrepancies_list',
      path: `${APP_PREFIX_PATH}/users_discrepancies_list`,
      title: 'users_discrepancies_list',
      isSeparator: true,
      defaultOpen: true,
      breadcrumb: true,
    },
    {
      key: 'users_timbs_analysis',
      path: `${APP_PREFIX_PATH}/users_timbs_analysis`,
      title: 'users_timbs_analysis',
      isSeparator: true,
      defaultOpen: true,
      breadcrumb: true,
    },

    
    ]
},
{
  key: 'users_nominees_list',
  path: `${APP_PREFIX_PATH}/users_nominees_list`,
  title: 'users_nominees_list',
  icon: UsergroupAddOutlined,
  submenu: []
},
{
  key: 'customers',
  path: `${APP_PREFIX_PATH}/customers`,
  title: 'customers',
  icon: IdcardOutlined,
  breadcrumb: true,
  submenu: []
},
{
  key: 'analysis',
  path: `${APP_PREFIX_PATH}/analysis`,
  title: 'analysis',
  icon: AreaChartOutlined,
  isSeparator: true,
  defaultOpen: false,
  breadcrumb: true,
  submenu: [
    /*{
      key: 'workload_analyis',
      parentKey: 'workload_analyis',
      path: `${APP_PREFIX_PATH}/workload_analyis`,
      title: 'workload_analyis',
      submenu: []
    },*/
    {
      key: 'masterplan_analysis',
      parentKey: 'masterplan_analysis',
      path: `${APP_PREFIX_PATH}/masterplan_analysis`,
      title: 'masterplan_analysis',
      submenu: []
    },
    {
      key: 'weekphaseplans_analysis',
      path: `${APP_PREFIX_PATH}/weekphaseplans_analysis`,
      title: 'weekphaseplans_analysis',
      isSeparator: true,
      defaultOpen: true,
      breadcrumb: true,
      
    },
    {
      key: 'personalconsumptiveonplan_analysis',
      path: `${APP_PREFIX_PATH}/personalconsumptiveonplan_analysis`,
      title: 'personalconsumptiveonplan_analysis_nav',
      isSeparator: true,
      defaultOpen: true,
      breadcrumb: true,
      
    },
    {
      key: 'order_receivals',
      path: `${APP_PREFIX_PATH}/order_receivals`,
      title: 'order_receivals',
      isSeparator: true,
      defaultOpen: true,
      breadcrumb: true,
    },
    {
      key: 'job_costs_analysis',
      parentKey: 'job_costs_analysis',
      path: `${APP_PREFIX_PATH}/job_costs_analysis`,
      title: 'job_costs_analysis',
      submenu: []
    },
  ]
},
{
  key: 'service',
  path: `${APP_PREFIX_PATH}/service`,
  title: 'service',
  icon: CustomerServiceOutlined,
  isSeparator: true,
  defaultOpen: false,
  breadcrumb: true,
  submenu: [
    {
      key: 'service_reports_validate_list',
      parentKey: 'service_reports_validate_list',
      path: `${APP_PREFIX_PATH}/service_reports_validate_list`,
      title: 'service_reports_validate_list',
      submenu: []
    },
    {
      key: 'service_hoursfixer',
      parentKey: 'service_hoursfixer',
      path: `${APP_PREFIX_PATH}/service_hoursfixer`,
      title: 'service_hoursfixer',
      submenu: []
    }
  ]
},
{
  key: 'production',
  path: `${APP_PREFIX_PATH}/production`,
  title: 'production',
  icon: ControlOutlined,
  isSeparator: true,
  defaultOpen: false,
  breadcrumb: true,
  submenu: [
    {
      key: 'job_materials',
      parentKey: 'job_materials',
      path: `${APP_PREFIX_PATH}/job_materials`,
      title: 'job_materials',
      submenu: []
    },
    {
      key: 'production_odp',
      parentKey: 'production_odp',
      path: `${APP_PREFIX_PATH}/production_odp`,
      title: 'production_odp',
      submenu: []
    },
    
    
    /*{
      key: 'production_material',
      parentKey: 'production_material',
      path: `${APP_PREFIX_PATH}/production_material`,
      title: 'production_material',
      submenu: []
    },*/
    {
      key: 'production_warehouse_material',
      parentKey: 'production_warehouse_material',
      path: `${APP_PREFIX_PATH}/production_warehouse_material`,
      title: 'production_warehouse_material',
      submenu: []
    },
    {
      key: 'order_rows',
      parentKey: 'order_rows',
      path: `${APP_PREFIX_PATH}/order_rows`,
      title: 'order_rows',
      submenu: []
    },
    {
      key: 'levrangi_material',
      parentKey: 'levrangi_material',
      path: `${APP_PREFIX_PATH}/levrangi_material`,
      title: 'levrangi_material',
      submenu: []
    }
  ]
},
{
  key: 'planning',
  path: `${APP_PREFIX_PATH}/planning`,
  title: 'planning',
  icon: ScheduleOutlined,
  isSeparator: true,
  defaultOpen: false,
  breadcrumb: true,
  submenu: [
    {
      key: 'planning_calendar',
      parentKey: 'planning_calendar',
      path: `${APP_PREFIX_PATH}/planning_calendar`,
      title: 'planning_calendar',
      submenu: []
    },
    {
      key: 'employees_calendar',
      parentKey: 'employees_calendar',
      path: `${APP_PREFIX_PATH}/employees_calendar`,
      title: 'employees_calendar',
      submenu: []
    },
    {
      key: 'plan',
      parentKey: 'plan',
      path: `${APP_PREFIX_PATH}/plan`,
      title: 'plan',
      submenu: []
    },
    {
      key: 'just_dashboard',
      parentKey: 'just_dashboard',
      path: `${APP_PREFIX_PATH}/just_dashboard`,
      title: 'just_dashboard',
      submenu: []
    },
    {
      key: 'away_analysis',
      parentKey: 'away_analysis',
      path: `${APP_PREFIX_PATH}/away_analysis`,
      title: 'away_analysis',
      submenu: []
    },
    {
      key: 'users_away_analysis',
      path: `${APP_PREFIX_PATH}/users_away_analysis`,
      title: 'users_away_analysis_old',
      isSeparator: true,
      defaultOpen: true,
      breadcrumb: true,
    },
  ]
},
{
  key: 'parameters',
  path: `${APP_PREFIX_PATH}/parameters`,
  title: 'parameters',
  icon: SettingOutlined,
  isSeparator: true,
  defaultOpen: false,
  breadcrumb: true,
  submenu: [
    {
      key: 'budgetAdjustments',
      parentKey: 'budgetAdjustments',
      path: `${APP_PREFIX_PATH}/budgetAdjustments`,
      title: 'budgetAdjustments',
      submenu: []
    },
    {
      key: 'workforce',
      parentKey: 'workforce',
      path: `${APP_PREFIX_PATH}/workforce`,
      title: 'workforce',
      submenu: []
    },
    {
      key: 'jobs_selector',
      parentKey: 'jobs_selector',
      path: `${APP_PREFIX_PATH}/jobs_selector`,
      title: 'jobs_selector',
      submenu: []
    },
    {
      key: 'oas_selector',
      parentKey: 'oas_selector',
      path: `${APP_PREFIX_PATH}/oas_selector`,
      title: 'oas_selector',
      submenu: []
    }
  ]
},
{
  key: 'help',
  path: `${APP_PREFIX_PATH}/help`,
  title: 'help',
  icon: QuestionCircleOutlined,
  breadcrumbHidden: true,
  submenu: []
}]

const extraNavTree = [
  
]

const navigationConfig = [
  ...dashBoardNavTree,
  ...extraNavTree
]

export default navigationConfig;
